export const uxProcess = [
  {
    id: 1,
    subTitle: "Empathasize, Understand and Define the problem.",
    skills: [
      "Job Mapping",
      "Mental Models",
      "Buisness opportunities",
      "Goals and Metrics"
    ],
    title: "Define"
  },
  {
    id: 2,
    subTitle: "Collect and Analyze pre-existing Solutions",
    skills: ["User Reaseach and Analysis", "Competitive Analysis"],
    title: "Research"
  },
  {
    id: 3,
    subTitle: "Brainstorm with Stakeholders",
    skills: ["System Desing / IA", "User Flow", "Feature Mapping"],
    title: "Ideate"
  },
  {
    id: 4,
    subTitle:
      "Sketch Ideas and exploring multiple approaches to solving the problem",
    skills: ["Concept Sketches", "Wireframes", "Positioning"],
    title: "Design"
  },
  {
    id: 5,
    subTitle: "Create mocks and Test them with stakeholders",
    skills: ["Concept Testing", "Content Inventory", "Prototype"],
    title: "FeedBack"
  },
  {
    id: 6,
    subTitle:
      "Refine the concepts and provide a detailed design for the best solution",
    skills: ["Visual Design", "Usability Testing", "Copy Decks"],
    title: "Refine"
  },
  {
    id: 7,
    subTitle:
      "Provide taskflows and other documentation to the developers and work alongside them to deliver",
    skills: [
      "Eng and Design Build",
      "Design QA",
      "Measure Success",
      "Customer Validation",
      "Marketting Assets"
    ],
    title: "Build"
  },
  {
    id: 7,
    subTitle:
      "Asses how delivered solution measures up to the initial goals and metrics",
    skills: [
      "Team Feedback",
      "Enhancements",
      "Measure and Optimize",
      "Feature Roadmap"
    ],
    title: "Test"
  }
];
